import { render, staticRenderFns } from "./channelConsultReport.vue?vue&type=template&id=b6185b90"
import script from "./channelConsultReport.vue?vue&type=script&lang=js"
export * from "./channelConsultReport.vue?vue&type=script&lang=js"
import style0 from "./channelConsultReport.vue?vue&type=style&index=0&id=b6185b90&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports